import type { ChecklistConfig, ChecklistItem } from './types';

function isItem(v: unknown): v is ChecklistItem {
  if (!v || typeof v !== 'object') return false;
  const o = v as Record<string, unknown>;
  return (
    typeof o.id === 'string' &&
    typeof o.label === 'string' &&
    typeof o.priorityOrder === 'number' &&
    typeof o.weekdaysOnly === 'boolean'
  );
}

export function validateConfig(raw: unknown): ChecklistConfig {
  if (!raw || typeof raw !== 'object') throw new Error('config must be an object');
  const r = raw as Record<string, unknown>;
  if (!Array.isArray(r.items)) throw new Error('config.items must be an array');

  for (const item of r.items) {
    if (!isItem(item)) {
      throw new Error(`invalid item — required fields: id, label, priorityOrder, weekdaysOnly. Got: ${JSON.stringify(item)}`);
    }
  }

  const items = r.items as ChecklistItem[];
  const seenIds = new Set<string>();
  const seenOrders = new Set<number>();
  for (const item of items) {
    if (seenIds.has(item.id)) throw new Error(`duplicate id: ${item.id}`);
    if (seenOrders.has(item.priorityOrder)) throw new Error(`duplicate priorityOrder: ${item.priorityOrder}`);
    seenIds.add(item.id);
    seenOrders.add(item.priorityOrder);
  }

  return { items: [...items].sort((a, b) => a.priorityOrder - b.priorityOrder) };
}
